import classNames from "classnames";

export interface MediaPreviewPlaceholderProps {
  className?: string;
}

export const MediaPreviewPlaceholder = ({ className }: MediaPreviewPlaceholderProps) => (
  <div className={classNames("bg-kds-bg-subtle", className)} aria-hidden />
);
